import { useEffect, useMemo, useState } from 'react';

import { Container, HeadCellSortState, Pagination, toggleSortStates, usePagination } from '@foradevelopment/fora-ui';

import { filterListIndicesOld, sortEmploymentListIndicesOld } from '../../common/utils';
import { useAppSelector } from '../../redux/hooks';
import {
  defaultEmploymentListSortState,
  EmploymentTableSortId,
  EmploymentTableSortState,
} from './EmploymentsTable/EmploymentTableSortState';
import { EmploymentsTableOld } from './EmploymentsTable/EmploymentsTableOld';

// TODO: REMOVE FILE MANAGE EMPLOYMENTS

const itemsPerPage = 25;

export const EmploymentsOverviewOld = ({
  searchInputValue,
  employmentsListChange,
}: {
  searchInputValue: string;
  employmentsListChange: (arg: number) => void;
}) => {
  const employments = useAppSelector(state => state.employment.employments);
  const [tableSortState, setTableSortState] = useState<EmploymentTableSortState>({
    ...defaultEmploymentListSortState,
    employeeId: HeadCellSortState.Asc,
  });
  const sortedAndFilteredEmploymentListIndices = useMemo(() => {
    const filteredEmploymentsIndices = filterListIndicesOld({
      employmentList: employments,
      searchQuery: searchInputValue,
    });
    return sortEmploymentListIndicesOld({
      employmentList: employments,
      sortState: tableSortState,
      indices: filteredEmploymentsIndices,
    });
  }, [employments, searchInputValue, tableSortState]);

  const { paginationProps, paginatedListIndices } = usePagination(sortedAndFilteredEmploymentListIndices, itemsPerPage);

  const sortTable = (sortId: EmploymentTableSortId) =>
    setTableSortState(state => {
      const newState = { ...defaultEmploymentListSortState };
      newState[sortId] = toggleSortStates(state[sortId]);
      return newState;
    });

  useEffect(() => {
    employmentsListChange(paginationProps.totalItems);
  }, [paginationProps.totalItems, employmentsListChange]);

  return (
    <Container className="notranslate">
      <EmploymentsTableOld
        employmentList={employments}
        employmentListIndices={paginatedListIndices}
        sortTable={sortTable}
        sortState={tableSortState}
      />
      <Pagination {...paginationProps} />
    </Container>
  );
};
